/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const IconAlert = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 22 23" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M15.91 8.05l-1-1.79A6.17 6.17 0 0 0 8.94 3.2a3 3 0 0 0-.41-1.66 3.1 3.1 0 0 0-5.37 3.1 3 3 0 0 0 1.23 1.18 6.16 6.16 0 0 0-.31 6.66l1 1.79c1.42 2.45 2.19 7.64 2.22 7.86a1 1 0 0 0 1.52.73l3.63-2.09a3.105 3.105 0 0 0 5.38-3.1l3.62-2.12a1 1 0 0 0 .12-1.67c-.13-.12-4.25-3.38-5.66-5.83zm.18 10.64a1.062 1.062 0 0 1-1.84 1.06l1.84-1.06zm-6.9 2.2a27 27 0 0 0-2.31-7.63l-1-1.8a4.2 4.2 0 0 1 7.27-4.19l1 1.8a27.41 27.41 0 0 0 5.47 5.82l-10.43 6zM6.37 4a1 1 0 0 1-1.45-.38 1.07 1.07 0 0 1 1.85-1.06A1.06 1.06 0 0 1 6.37 4zM17.68 3.38a1 1 0 0 0-1.25.71 1 1 0 0 0 .72 1.25 2.44 2.44 0 0 1 1.73 3 1 1 0 0 0 1.49 1.14 1 1 0 0 0 .48-.62 4.47 4.47 0 0 0-3.17-5.48zM2 13.23a1 1 0 0 0-.62-.47 1 1 0 0 0-1.24.72 4.4 4.4 0 0 0 .44 3.4A4.44 4.44 0 0 0 3.33 19a1 1 0 0 0 .77-.1 1 1 0 0 0 .47-.62 1 1 0 0 0-.09-.77 1 1 0 0 0-.62-.51 2.39 2.39 0 0 1-1.49-1.14A2.43 2.43 0 0 1 2.12 14a1 1 0 0 0-.12-.77z" /></g>
      </g>
    </svg>
  </span>
);

IconAlert.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

IconAlert.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default IconAlert;
